if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url')+'.js')
        .then(response => response.json())
        .then(product => {

          if(product.compare_at_price > product.price){
            var compare_at_price = Shopify.formatMoney(product.compare_at_price,Shopify.money_format)
            var price = Shopify.formatMoney(product.price,Shopify.money_format);
          }else{
            var compare_at_price = '';
            var price = Shopify.formatMoney(product.price,Shopify.money_format);
          }
          var model_id = opener.closest('modal-opener').getAttribute('data-modal');
          
          $(model_id).find('.quick-add-modal__content-info').html(`
            <div class="quick-add__product-details">
              <div class="quick-add-info">
                 <div class="quick-add-info__media">
                 </div>
                 <div class="quick-add-info__details">
                   <div class="product-title">
                     <a class="h6 js-prod-link" href="${product.url}">
                        ${product.title}
                     </a>
                   </div>
                   <hr>
                   
                   

                   <div class="product-view">
                     <a href="${product.url}">View details</a>
                   </div>
                   
                 </div>
              </div>

              <div class="product-options">
                <div class="variant-selects">
                  
                </div>
                <div class="master-selected" style="display:none;">
                  <select></select>
                </div>
              </div>

              
              
            </div>
          `);
          var prod_media = product.media;
         
          if(prod_media.length != 0){                                           
            prod_media.forEach(function(item) {
              if(item.position == 1){
                $(model_id).find('.quick-add-info__media').append(`
                  <div class="media-wrapper" data-id="${item.id}" style="display:block;">
                    <img src="${item.src}">
                  </div>
                `);
              }else{
                $(model_id).find('.quick-add-info__media').append(`
                  <div class="media-wrapper" data-id="${item.id}" >
                    <img src="${item.src}">
                  </div>
                `);
              }
              
            });
          }

          var master_select = product.variants;
          master_select.forEach((variant) => {
            if(variant.available != true){
              var sold_out = "disabled";
            }else{
              var sold_out = '' ;
            }
            $(model_id).find('.master-selected select').append(`
              <option value="${variant.id}" data-title="${variant.title}" ${sold_out}>${variant.title}</option>
            `);
          });

          
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          // super.show(opener);
        })
        .finally(() => {
          // opener.removeAttribute('aria-disabled');
          // opener.classList.remove('loading');
          // opener.querySelector('.loading__spinner').classList.add('hidden');
        });

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info variant-selects');

            this.preprocessHTML(productElement);
            // HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // if (window.Shopify && Shopify.PaymentButton) {
            //   Shopify.PaymentButton.init();
            // }
            // if (window.ProductModel) window.ProductModel.loadShopifyXR();
            var model_id = opener.closest('modal-opener').getAttribute('data-modal');
            $(model_id).find('.product-options .variant-selects').html(productElement);

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

$(document).on("change", ".quick-add-modal__content-info .product-quote-list textarea", function (e) {
  $('#quick-drawer-Note').attr('value',$(this).val());
});

$(document).on("click", ".quick-add-modal__content-info .product-form__input input", function (e) {
  // e.preventDefault();
  var selectedVal = $(this).closest('variant-selects').find('fieldset');
  var variantTitle = [];
  for (var i = 0; i < selectedVal.length; i++) {
    var valueItem = selectedVal[i].querySelector('.quick-add__product-details input:checked').getAttribute("value");
    variantTitle.push(valueItem);
  }
  var variantValue = variantTitle.join(" / ").trim();
  var masterSelect = $(".quick-add-modal__content-info .master-selected option");
  for (var k = 0; k < masterSelect.length; k++) {
    var defaultValue = masterSelect[k].getAttribute("data-title").trim();
    if (defaultValue == variantValue) {
      masterSelect[k].selected = true;
    }
  }
  var available = $(this).closest('.product-options').find(".master-selected option:selected").attr('disabled');
  var variantId = $(this).closest('.product-options').find(".master-selected option:selected").val();
  $(this).closest('quick-add-modal').find('product-form .product-variant-id').attr('value',variantId);
  var add_to_cart_btn = $(this).closest('quick-add-modal').find('product-form .quick-add__submit');
  if(available == 'disabled'){
    add_to_cart_btn.attr('aria-disabled','true');
    add_to_cart_btn.find('span:first-child').addClass('hidden');
    add_to_cart_btn.find('.sold-out-message').removeClass('hidden');
  }else{
    add_to_cart_btn.removeAttr('aria-disabled');
    add_to_cart_btn.find('span:first-child').removeClass('hidden');
    add_to_cart_btn.find('.sold-out-message').addClass('hidden');
  }
  
});